import { Box, Separator, Text } from '@chakra-ui/react';
import { InfoIcon } from './icons/Icon';
import {
    PopoverArrow,
    PopoverBody,
    PopoverCloseTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverRoot,
    PopoverTrigger
} from "@/components/ui/popover"

interface ExplanationPopoverProps {
    explanation: string | string[];
}

const ExplanationPopover = ({ explanation }: ExplanationPopoverProps) => (
    <PopoverRoot>
        <PopoverTrigger>
            <Box mr='.2rem' bg='gray.200' p='.2rem' rounded='sm' cursor='pointer'>
                <InfoIcon w='1rem' h='1rem' color='blue' aria-label='weitere Erklärung' />
            </Box>
        </PopoverTrigger>
        <PopoverContent>
            <PopoverArrow />
            <PopoverCloseTrigger />
            <PopoverHeader><Text fontWeight='semibold' textTransform='none'>Erklärung</Text></PopoverHeader>
            <Separator />
            <PopoverBody>
                {(Array.isArray(explanation) ? explanation : [explanation]).map((line, index, lines) => (
                    <Text key={`${line}-${index}`} fontWeight='normal' textTransform='none'
                        fontSize={lines.length > 1 && index === lines.length - 1 ? 'xs' : undefined}>{line}</Text>
                ))}
            </PopoverBody>
        </PopoverContent>
    </PopoverRoot>
)

export default ExplanationPopover
